export const ENVIRONMENT: 'development' | 'production' | 'demo' = 'production'
export const REVISION: string = '9426bc9769199038aa9ef7d9346a4b052e3c7f92'



// WEBPACK FOOTER //
// ./src/config/environment.ts